import React from 'react';
import classnames from 'classnames';
import TextHR from './TextHR';
import styles from './styles.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function HR({ thick, light, variant, marginClass, className }) {
  const colorClass =
    variant === 'accent'
      ? styles.accent
      : variant === 'extraLight'
      ? styles.lightGrey
      : variant === 'light' || light
      ? styles.grey
      : styles.gold;

  return (
    <hr
      className={classnames(
        thick ? styles.borderThick : styles.border,
        marginClass ? marginClass : `${margin.left_0} ${margin.right_0}`,
        colorClass,
        className
      )}
    />
  );
}

export function LightHR(props) {
  return <HR variant="light" {...props} />;
}

export function ExtraLightHR(props) {
  return <HR variant="extraLight" {...props} />;
}

export function AccentHR(props) {
  return <HR variant="accent" {...props} />;
}

export { TextHR };
